/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BasePurchaseSummary } from './BasePurchaseSummary';
import { TenantAccessPlan } from './TenantAccessPlan';
const AccessPlanPurchaseSummaryParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['scope', /* #__PURE__ */ parsers.exactly('access-plan')],
    ['purchasedItem', TenantAccessPlan, 'purchased_item'],
]), BasePurchaseSummary);
export class AccessPlanPurchaseSummary extends BasePurchaseSummary {
    static decode(input) {
        return AccessPlanPurchaseSummaryParser.decode(input).map(res => new AccessPlanPurchaseSummary(res));
    }
    static unsafeDecode(input) {
        return AccessPlanPurchaseSummary.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AccessPlanPurchaseSummaryParser.encode(data);
    }
    static schema() {
        return AccessPlanPurchaseSummaryParser.schema();
    }
}
